import { slices } from "@/constants/sliceNames";
import { Alert } from "@/entities/Alert";
import {
  createAlertStatuses,
  deleteAlertStatus,
  getAlertStatuses,
  requestAlertsStatus,
  updateAlertStatuses,
} from "@/store/effects/admin-dashboard/alerts-effects";
import { createSlice } from "@reduxjs/toolkit";

/**
 * @type {{
 * loading: boolean,
 * alerts: Alert[]
 * }}
 */
const initialState = {
  loading: false,
  alerts: [],
  alert: null,
  pageLimit: null,
  currentPage: null,
  totalPages: null,
  recordsCount: null,
};

const alertsSlice = createSlice({
  name: slices.alerts,
  initialState,
  reducers: {
    resetAlerts: () => initialState,
  },
  extraReducers: {
    ...requestAlertsStatus,
    ...deleteAlertStatus,
    ...createAlertStatuses,
    ...getAlertStatuses,
    ...updateAlertStatuses,
  },
});

const { actions, reducer } = alertsSlice;
const { resetAlerts } = actions;

export { actions, initialState, resetAlerts };

export default reducer;
